import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Output,
    ViewChild
} from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { NachrichtAction } from '../nachricht-action-buttons/nachricht-action.enum';
import { NachrichtSummary } from '../../../core/model/nachricht/nachricht';
import { OrdnerEnum } from '../../../core/model/ordner.enum';
import { NachrichtActionHandlerToken, NachrichtActionHandler } from './nachricht-action-handler';
import {I18NextPipe} from "@kokos-i18next";

@Component({
    selector: 'pf-nachricht-action-modals',
    standalone: true,
    imports: [I18NextPipe, ModalComponent],
    providers: [
        { provide: NachrichtActionHandlerToken, useClass: NachrichtActionService } // Hinweis: siehe Import unten
    ],
    templateUrl: './nachricht-action-modals.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class NachrichtActionModalsComponent implements AfterViewInit {

    @Output() reload = new EventEmitter<OrdnerEnum>();

    @ViewChild('restoredModal', { static: false }) restoredModal!: ModalComponent;
    @ViewChild('restoredErrorModal', { static: false }) restoredErrorModal!: ModalComponent;
    @ViewChild('deletedModal', { static: false }) deletedModal!: ModalComponent;
    @ViewChild('deleteErrorModal', { static: false }) deleteErrorModal!: ModalComponent;
    @ViewChild('deleteIrrevocableConfirmModal', { static: false }) deleteIrrevocableConfirmModal!: ModalComponent;
    @ViewChild('deletedIrrevocableModal', { static: false }) deletedIrrevocableModal!: ModalComponent;

    nachrichtActionHandler = inject<NachrichtActionHandler>(NachrichtActionHandlerToken);
    protected readonly nachrichtAction = NachrichtAction;

    currentNachricht!: NachrichtSummary;

    private pendingReload: OrdnerEnum | null = null;

    ngAfterViewInit(): void {
        this.nachrichtActionHandler.registerModal('RESTORE-success', this.restoredModal);
        this.nachrichtActionHandler.registerModal('RESTORE-error', this.restoredErrorModal);
        this.nachrichtActionHandler.registerModal('DELETE-success', this.deletedModal);
        this.nachrichtActionHandler.registerModal('DELETE-error', this.deleteErrorModal);
        this.nachrichtActionHandler.registerModal('DELETE_IRREVOCABLE-confirm', this.deleteIrrevocableConfirmModal);
        this.nachrichtActionHandler.registerModal('DELETE_IRREVOCABLE-success', this.deletedIrrevocableModal);
        this.nachrichtActionHandler.registerModal('DELETE_IRREVOCABLE-error', this.deleteErrorModal);
    }

    handleAction(action: NachrichtAction, nachricht: NachrichtSummary, confirmed?: boolean): void {
        this.currentNachricht = nachricht;
        this.nachrichtActionHandler.handleAction(action, nachricht, confirmed).subscribe((ordnerEnum) => {
            if (action === NachrichtAction.DELETE_IRREVOCABLE) {
                this.pendingReload = ordnerEnum;
                return;
            }

            if (ordnerEnum) {
                this.reload.emit(ordnerEnum);
            }
        });
    }

    emitPendingReload(): void {
        if (this.pendingReload) {
            this.reload.emit(this.pendingReload);
            this.pendingReload = null;
        }
    }

}

// Wichtig: nach unten verschoben, um Zirkular-Imports zu vermeiden
import { NachrichtActionService } from '../../../core/services/nachricht-action.service';